import React from 'react';
import IconLocation from '../../../../../components/icon/IconLocation';
import './statisticcity.scss';

const StatisticCity = ({ city, application, tranch }) => {
  return (
    <div className="statistic_city_modal">
      <div className="statistic_city">
        <IconLocation /> {city}
      </div>
      <div className="statistic_application">Количество заявок</div>
      <div className="statistic_count">{application}</div>
      <span className="statistic_line"></span>
      <div className="statistic_application">Количество траншов</div>
      <div className="statistic_count">{tranch}</div>
    </div>
  );
};

export default StatisticCity;
